module.exports = __webpack_public_path__ + "static/img/Daniel-Talia.a0d7278.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel-Talia.jpg
// module id = 4rm1
// module chunks = 0